<template>
  <v-row class="pt-5" align="center" justify="center">
    <v-col :cols="11" :xs="10" :sm="10" :md="8" :lg="8" :xl="5">
      <!-- v-input__append-inner margin top -->
      <v-text-field
        class="custom-placeholer-color text-white"
        v-model="query"
        placeholder="Transaction id, Address..."
        height="48"
        color="#FFFFFF"
        outlined
        :readonly="isSearching"
        @keyup.enter="search"
      >
        <template v-slot:append v-on:click="search">
          <img
            :src="require(`@/assets/common_icon/ico_search.svg`)"
            @click="search"
          />
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      query: "",
      apiUrl: `${this.$config.apiEndPoint}/token`,
      transactionIdLength: 44,
      addressLength: 35,
      isSearching: false
    };
  },
  computed: {
    ...mapState(["tokenId", "reloadPage", "showError"])
  },
  methods: {
    ...mapMutations([
      "updateQueryAnswer",
      "updateReloadPage",
      "updateShowError",
      "updateErrorMsg"
    ]),
    async search() {
      this.query = this.query ? this.query.replace(/\s+/g, "") : null;
      const that = this;
      if (!this.query) {
        // return to home page
        this.updateReloadPage(true);
        setTimeout(() => {
          that.updateShowError(false);
          that.updateReloadPage(false);
        }, 500);
        if (this.$router.currentRoute.name !== "general") {
          this.$router.push({ name: "general" });
        }
        return;
      }
      if (!this.query.match("^[A-Za-z0-9]+$")) {
        const errorMsg = "Invalid query. Please ensure precision of query.";
        this.updateShowError(true);
        this.updateErrorMsg(errorMsg);
        return;
      }
      this.updateReloadPage(true);
      this.$emit("listenChild", { goal: "SearchStart", value: true });
      this.isSearching = true;
      const length = this.query.length;
      let url = null;
      let destination = "transactionDetail";
      if (
        length === this.addressLength &&
        (this.query.startsWith("AT") ||
          this.query.startsWith("AR") ||
          this.query.startsWith("AU"))
      ) {
        destination = "addressDetail";
        url = `/address/${this.query}`;
      } else {
        url = `/transaction/${this.query}`;
      }
      const curUrl = this.$router.currentRoute.fullPath;
      setTimeout(() => {
        that.isSearching = false;
        that.updateReloadPage(false);
      }, 500);
      if (!url) {
        const errorMsg = "Invalid query. Please ensure precision of query.";
        this.updateShowError(true);
        this.updateErrorMsg(errorMsg);
      } else {
        // if App.vue presents error page, disable error page when get new query answer
        if (this.showError) {
          this.updateShowError(false);
        }
        if (
          url.length !== curUrl.length &&
          destination !== this.$router.currentRoute.name
        ) {
          this.$router.push({
            path: url
          });
        } else if (url !== curUrl) {
          this.$router.replace({
            path: url
          });
        }
      }
    }
  }
};
</script>
<style>
.custom-placeholer-color input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
  opacity: 0.7;
}
.text-white input {
  color: #ffffff !important;
}
</style>
<style scoped>
.v-text-field--outlined >>> .v-input__control > .v-input__slot {
  min-height: 20px !important;
}
/* .explorer-text-style >>> .v-text-field__slot input {
    color: #FFFFFF
  } */

.theme--light.v-text-field--outlined >>> fieldset {
  border-color: rgba(255, 255, 255, 0.4) !important;
}
</style>
